import styled from 'styled-components';

export const StyledLogo = styled.div`
  margin: 0 auto 0;
  max-height: 25px;
  min-width: 120px;

  & > svg {
    max-height: inherit;
  }
`;
